// A strict null check, not a falsy one: a stored score of 0 is a real score and
// must export as '0.0' rather than as unrated.
//
// `unscoredLabel` lets a caller that knows *why* a score is missing say so:
// under an aggregation model a risk an interrupted recalculation never reached
// reads "Not calculated", not "Unrated" (RSP-7301). It defaults to the literal
// the register used before that distinction existed, for callers with no such
// context.
export const scoreExportVal = (
  score: number | null | undefined,
  unscoredLabel = 'Unrated'
): string =>
  score === null || score === undefined ? unscoredLabel : score.toFixed(1);
